import request from '../../untils/request';

export function selectInvalidList(data) {
  return request({
    url: '/lessee/selectInvalidList',
    method: 'get',
    params: data,
  });
}
export function cancelAccountDetail(data) {
  return request({
    url: '/cancelAccount',
    method: 'get',
    params: data,
  });
}
// 获取商户名称下拉列表
export function selectListLesseeName(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}
